import React, { useEffect, useState, forwardRef, useRef, memo } from 'react'
import { VariableSizeList as List, areEqual } from 'react-window'

const OVER_SCAN_COUNT = 10
const SCROLL_HEIGHT = 420

function listVirtualScoller ({ children, ...props }, ref) {
  const { listData, focusedItemIndex, renderListItem: RenderListItem } = props
  const [data, setData] = useState(listData)
  const recordCountref = useRef(0)
  const rowHeights = useRef({})

  useEffect(() => {
    if (recordCountref.current !== listData.length) {
      setData(listData)
      recordCountref.current = listData.length
    }
  }, [listData])

  useEffect(() => {
    ref.current && ref.current.scrollToItem(focusedItemIndex)
  }, [focusedItemIndex])

  // return JSX for individual options of the dropdown
  const row = memo(({ index, style }) => {
    const rowRef = useRef({})

    useEffect(() => {
      if (rowRef.current && ref.current) {
        setRowHeight(index, rowRef.current.clientHeight)
      }
    }, [rowRef])

    function setRowHeight (index, size) {
      ref.current.resetAfterIndex(0)
      rowHeights.current = { ...rowHeights.current, [index]: size }
    }

    const datum = data[index]
    const listItemstyle = { ...style, padding: 0 }
    return (
      <RenderListItem data={datum} index={index} style={listItemstyle} ref={rowRef} />
    )
  }, areEqual)

  // Method to get dynamic heights of individual options
  const getRowHeight = (index) => rowHeights.current[index] || 47

  return (
    <List
      height={SCROLL_HEIGHT}
      innerElementType='div'
      itemCount={data.length}
      itemSize={getRowHeight}
      overscanCount={OVER_SCAN_COUNT}
      ref={ref}
      {...props}
    >
      {row}
    </List>
  )
}

/**
 * @template T
 * @template Item
 * @type {import('react').ForwardRefExoticComponent<import('./interfaces').ListProps<T, Item> & React.RefAttributes<HTMLElement>>}
 */
const ListVirtualScoller = React.memo(forwardRef(listVirtualScoller))

export default ListVirtualScoller

ListVirtualScoller.displayName = 'ListVirtualScoller'
